import { render, staticRenderFns } from "./VoiceRecorderLock.vue?vue&type=template&id=47f4b479&"
import script from "./VoiceRecorderLock.vue?vue&type=script&lang=js&"
export * from "./VoiceRecorderLock.vue?vue&type=script&lang=js&"
import style0 from "./VoiceRecorderLock.vue?vue&type=style&index=0&id=47f4b479&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports